import { Box, Grid } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import { useTheme } from '@mui/material/styles'
import moment from 'moment'
import ImageComponent from '../../../commonComponents/ImageComponent'
import appassets from '../../../utils/appassets'

export default function JobDetails (props) {
  const theme = useTheme()

  const location = useLocation()
  const data = location.state || {}

  return (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      <Grid
        item
        md={4.25}
        xs={12}
        style={{
          display: 'flex',
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.border.main}`,
          borderRadius: '16px',
          padding: '24px',
          flexDirection: 'column'
        }}
      >
        <Grid>
          <ImageComponent
            alt='company logo'
            src={data.item.profilePicture}
            style={{
              display: 'flex',
              border: `1px solid ${theme.palette.border.main}`,
              width: '65px',
              height: '65px',
              borderRadius: '16px',
              overflow: 'hidden',
              padding: '4px',
              objectFit: 'contain'
            }}
          />
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            marginTop: '16px'
          }}
        >
          <TextBold
            style={{ color: theme.palette.primary.main, fontSize: '16px' }}
          >
            {data?.item?.companyname}
          </TextBold>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '8px'
          }}
        >
          <img
            src={`${appassets.location}`}
            alt='location'
            style={{ marginRight: '8px' }}
          />
          <TextRegular
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              lineHeight: '24px',
              color: theme.palette.text.secondary,
              paddingRight: '16px'
            }}
          >
            {data.item.city}
          </TextRegular>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '8px'
          }}
        >
          <img
            src={`${appassets.time}`}
            alt='time'
            style={{ marginRight: '8px' }}
          />
          <TextRegular
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              lineHeight: '24px',
              color: theme.palette.text.secondary,
              paddingRight: '16px'
            }}
          >
            {moment(data.item?.createdAt).fromNow()}
          </TextRegular>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '8px'
          }}
        >
          <img
            src={`${appassets.suitcase}`}
            alt='suitcase'
            style={{ marginRight: '8px' }}
          />
          <TextRegular
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              lineHeight: '24px',
              color: theme.palette.text.secondary,
              paddingRight: '16px'
            }}
          >
            {data.item.jobTypeName}
          </TextRegular>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            marginTop: '32px',
            flexDirection: 'column'
          }}
        >
          <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Job Title:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.jobTitle}
            </TextRegular>
          </Grid>

          <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Job type:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.jobTypeName}
            </TextRegular>
          </Grid>

          <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Job function:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.jobFunctionName}
            </TextRegular>
          </Grid>

          {/* <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Industry:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.jobIndustryName}
            </TextRegular>
          </Grid> */}

          {/* <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Education level:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.educationLevelName}
            </TextRegular>
          </Grid> */}

          <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Experience level:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.experienceLevelName}
            </TextRegular>
          </Grid>

          {/* <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Job classification:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >

            </TextRegular>
          </Grid> */}

          <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              City:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.city}
            </TextRegular>
          </Grid>

          {/* <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              State:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.state}
            </TextRegular>
          </Grid> */}

          {/* <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Country:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.countryName}
            </TextRegular>
          </Grid> */}

          {/* <Grid
            item
            style={{
              display: 'flex'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Zip code:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.zipCode}
            </TextRegular>
          </Grid> */}
        </Grid>
      </Grid>
      <Grid
        item
        md={7.5}
        xs={12}
        style={{
          display: 'flex',
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.border.main}`,
          borderRadius: '16px',
          padding: '24px',
          flexDirection: 'column'
        }}
      >
        <Grid item>
          <TextBold
            style={{ color: theme.palette.primary.main, fontSize: '16px' }}
          >
            Job Description
          </TextBold>
        </Grid>
        <Grid item xs={12}>
          <TextRegular
            style={{ color: theme.palette.text.secondary, fontSize: '16px' }}
          >
            <Box
              dangerouslySetInnerHTML={{
                __html: data.item.jobDescription
              }}
            />
          </TextRegular>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex'
          }}
        >
          <TextBold
            style={{ fontSize: '16px', color: theme.palette.text.secondary }}
          >
            Skills:
          </TextBold>
          <TextRegular
            style={{
              fontSize: '16px',
              color: theme.palette.text.secondary,
              marginLeft: '5px'
            }}
          >
            {data.item.skillRequired
              .split(',')
              .map(skill => skill.trim())
              .map(skill => skill.charAt(0).toUpperCase() + skill.slice(1))
              .join(' | ')}
          </TextRegular>
        </Grid>

        {/* <Grid
          item
          style={{
            display: 'flex',
            marginTop: '8px'
          }}
        >
          <TextBold
            style={{ fontSize: '16px', color: theme.palette.text.secondary }}
          >
            Experience Required:
          </TextBold>
          <TextRegular
            style={{
              fontSize: '16px',
              color: theme.palette.text.secondary,
              marginLeft: '5px'
            }}
          >
            {data.item.requiredExpYear} years
            {data.item.requiredExpMonth ? (
              <>, {data.item.requiredExpMonth} months</>
            ) : (
              <></>
            )}
          </TextRegular>
        </Grid> */}

        {/* <Grid
          item
          style={{
            display: 'flex',
            marginTop: '8px'
          }}
        >
          <TextBold
            style={{ fontSize: '16px', color: theme.palette.text.secondary }}
          >
            Relocation Assistance:
          </TextBold>
          <TextRegular
            style={{
              fontSize: '16px',
              color: theme.palette.text.secondary,
              marginLeft: '5px'
            }}
          >
            {data.item.relocationAssistanceName}
          </TextRegular>
        </Grid> */}
        <Grid
          item
          style={{
            display: 'flex',
            marginTop: '8px'
          }}
        >
          <TextBold
            style={{ fontSize: '16px', color: theme.palette.text.secondary }}
          >
            Job Deadline:
          </TextBold>
          <TextRegular
            style={{
              fontSize: '16px',
              color: theme.palette.text.secondary,
              marginLeft: '5px'
            }}
          >
            {data.item.jobDeadline}
          </TextRegular>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            marginTop: '8px'
          }}
        >
          <TextBold
            style={{ fontSize: '16px', color: theme.palette.text.secondary }}
          >
            Budget:
          </TextBold>
          <TextRegular
            style={{
              fontSize: '16px',
              color: theme.palette.text.secondary,
              marginLeft: '5px'
            }}
          >
            {data.item.budget}
          </TextRegular>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            marginTop: '32px'
          }}
        >
          <Grid>
            <TextBold
              style={{ color: theme.palette.primary.main, fontSize: '16px' }}
            >
              Job Positions
            </TextBold>
          </Grid>
          <Grid
            item
            style={{
              display: 'flex',
              marginTop: '8px'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Number of position:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.totalPositions}
            </TextRegular>
          </Grid>

          <Grid
            item
            style={{
              display: 'flex',
              marginTop: '8px'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Number of open position:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.totalPositions - data.item.closedPositions}
            </TextRegular>
          </Grid>

          {/* <Grid
            item
            style={{
              display: 'flex',
              marginTop: '8px'
            }}
          >
            <TextBold
              style={{ fontSize: '16px', color: theme.palette.text.secondary }}
            >
              Number of filled position:
            </TextBold>
            <TextRegular
              style={{
                fontSize: '16px',
                color: theme.palette.text.secondary,
                marginLeft: '5px'
              }}
            >
              {data.item.closedPositions}
            </TextRegular>
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  )
}
